/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IPublicV1GetOrCreateChatRequest {
  /** URL страницы, с которой был инициирован чат **/
  pageUrl?: TPublicV1GetOrCreateChatRequest_PageUrl;
  /** JSON query **/
  jsonQuery?: TPublicV1GetOrCreateChatRequest_JsonQuery;
  /** Страница, с которой был инициирован чат **/
  sourcePage?: TPublicV1GetOrCreateChatRequest_SourcePage;
  /** Идентификатор региона **/
  regionId?: TPublicV1GetOrCreateChatRequest_RegionId;
}

export type TPublicV1GetOrCreateChatRequest_PageUrl = null | string;

export type TPublicV1GetOrCreateChatRequest_JsonQuery = null | TPublicV1GetOrCreateChatRequest_JsonQuery_1;

export type TPublicV1GetOrCreateChatRequest_JsonQuery_1 = object;

export type TPublicV1GetOrCreateChatRequest_SourcePage = null | ESourcePage;

export enum ESourcePage {
  /** Выдача новостроек **/
  'NewbuildingsList' = 'newbuildingsList',
  /** Выдача объявлений **/
  'OffersList' = 'offersList',
  /** Карточка объявления **/
  'OfferCard' = 'offerCard',
  /** Карточка новостройки **/
  'NewbuildingCard' = 'newbuildingCard',
  /** Список чатов **/
  'ChatsList' = 'chatsList',
  /** Циан Помощник **/
  'CianAssistant' = 'cianAssistant',
}
export type TPublicV1GetOrCreateChatRequest_RegionId = null | number;
